import { neutral8 } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&.Mui-disabled': {
      color: neutral8,
    },
    '&.MuiInputLabel-root': {
      overflow: 'visible',
    },
  },
  asterisk: {
    marginLeft: idsTokens.label.default.spacing.padding.gap,
    color: idsTokens.label.default.color.asterisk,
    position: 'relative',
    bottom: 2,
    left: 3,
  },
});
